import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURFeatureModel from "../models/BURFeatureModel";

export class BURHasEnergyChargeFeatureCondition implements ICondition {
    public check(): boolean {
        return (
            BURFeatureModel.will_base_game_feature_trigger &&
            BURFeatureModel.base_game_features_to_trigger.some(
                (feat) => feat === "EnergyCoins"
            )
        );
    }
}
